// 构建多字段信息字符串，默认空格分隔
export const composeStrs = (strs: string[], splitor = ' '): string => {
  if (!Array.isArray(strs)) return '';
  return strs.filter((str) => !!str).join(splitor);
};
